import styled from '@emotion/styled'

export const StyleSvgWrappeer = styled.span<{ translateY?: string }>`
  transform: translateY(${(props: any) => props.translateY || '4px'});
  margin-right: 5px;
`
